export default __webpack_public_path__ + "static/header-d256b4c5930e50c16d6a456be6e8213e.jpeg";